/* ------------------------------------------------------------------ */
/* Exported flag so other modules know which vendors failed to attach */

import { isBrowser } from "@/utils/runtime"

/* ------------------------------------------------------------------ */
const initedPixels = new Set()

export const sdkFailed = {
  GA4: false,
  FBPX: false
}

const GA_SCRIPT_ID = 'ga-bootstrap'
const FB_SCRIPT_ID = 'fb-pixel'

/* ---------- GA4 loader ------------------------------------------- */
export function initGA(streamId) {
  if (!isBrowser) return // SSR guard only

  const firstLoad = !document.getElementById(GA_SCRIPT_ID)
  let s; 
  if (firstLoad) {
    s = document.createElement('script')
    s.id = GA_SCRIPT_ID
    s.async = true
    s.src = `https://www.googletagmanager.com/gtag/js?id=${streamId}`
    s.onerror = () => {
      sdkFailed.GA4 = true
    } // instant fail flag
    document.head.appendChild(s)

    window.dataLayer = window.dataLayer || []
    function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag = window.gtag || gtag
    window.gtag('js', new Date())
  }
  // Always (re)-register the passed stream
  if (firstLoad) {
    s.onload = () => window.gtag('config', streamId)
  } else if (window.gtag) {
    window.gtag('config', streamId)
  }

  /* probe after 1 s — if gtag is still the stub, mark failure */
  setTimeout(() => {
    if (!sdkFailed.GA4) {
      try {
        window.gtag('event', '_probe')
      } catch {
        sdkFailed.GA4 = true
      }
    }
  }, 1000)
}

/* ---------- Facebook Pixel loader -------------------------------- */
export function initFacebook(pixelId) {
  if (!isBrowser) return
  if (initedPixels.has(pixelId)) return;

  if (!window.fbq) {
    ;(function (f, b, e, v, n, t, s) {
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.id = FB_SCRIPT_ID
      t.async = !0
      t.src = v
      t.onerror = () => {
        sdkFailed.FBPX = true
      }
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  }
  window.fbq('init', pixelId, {}, false)
  window.fbq('track', 'PageView')
  initedPixels.add(pixelId);

  setTimeout(() => {
    try {
      window.fbq('track', '_Probe')
    } catch {
      sdkFailed.FBPX = true
    }
  }, 1000)
}
